import React from 'react';
import {_GPY,__GPYPost} from '../../env.js'
import GpyFileUpload from '../gametypes/lib/GpyFileUpload.js'

class Fonts extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			fonts: [],
		};
	}

	onFileUpload(file) {
		_GPY.loadFonts(()=>{
			this.setState({fonts : _GPY.userFonts});
		});
  }

	deleteFont (f) {
		__GPYPost('deleteFont',{font:f},(res)=>{
			if(res.Result.resultDataAsList !== undefined) {
				this.setState({fonts : res.Result.resultDataAsList});
				_GPY.loadFonts(()=>{
					this.setState({fonts : _GPY.userFonts});
				});
			}
		},(res)=>{
		});
	}

	componentDidMount() {
		_GPY.loadFonts(()=>{
			this.setState({fonts : _GPY.userFonts});
		});
	}

	render () {
		  return (<div>
					<div className="row">
						<div className="col-12 pt-2">
								<div className="card bg-light">
									 <div className="card-header">Fonts</div>

											<ul className="list-group list-group-flush pt-3">
												<li class="list-group-item  d-flex justify-content-between align-items-center">
													<span>{_GPY.i18n.get('gametype_fonts_headline_description')}</span>
												<GpyFileUpload aspectRatio="1" fileTypes="ttf" className="btn btn-secondary mr-2"  callBack={(f)=>this.onFileUpload(f)} />
													</li>
													</ul>

									<ul className="list-group list-group-flush  pt-3">
											{this.state.fonts.map((font)=>{
												return (
													<li class="list-group-item  d-flex justify-content-between align-items-center">
															<span>{_GPY.fontUrlToName(font)}</span>
															<span style={{fontFamily: _GPY.fontUrlToName(font),fontSize:"40px"}}>{_GPY.fontUrlToName(font)}</span>
															<button className="btn btn-danger align-right" onClick={()=>this.deleteFont(font)}>delete</button>
													</li>
												);
											})}
									</ul>


								</div>
						</div>
					</div>


				</div>);
	} // end return

}
export default Fonts;
